/**
 * Fixed raster settings for figure extraction.
 *
 * The playground tuned these values; they are frozen here so the admin
 * playground and the production import pipeline rasterise a figure the same
 * way. Change a value here and both paths follow. Do not fork these numbers.
 *
 * @format
 */

/** Settings for the trimmed backup raster of one figure. */
export interface FigureRasterSettings {
	/** Render resolution of the page, as a multiplier of the PDF point grid. */
	scale: number;
	/** Percent (0-100) of the horizontal gap to the content frame to fill per side. */
	padPctX: number;
	/** Percent (0-100) of the vertical gap to the content frame to fill per side. */
	padPctY: number;
	/** Breathing margin around the trimmed content, in points. */
	trimMargin: number;
	/** Maximum distance a word box may pull the trim from the figure, in points. */
	trimReach: number;
}

/**
 * The frozen values the playground settled on. The trimmed raster crops a
 * padded region to the figure and the words drawn on its SVG, so it drops white
 * space and unrelated items while keeping the figure's own labels.
 */
export const FIGURE_RASTER_SETTINGS: FigureRasterSettings = {
	scale: 3,
	padPctX: 100,
	padPctY: 50,
	trimMargin: 6,
	trimReach: 42,
};
